import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Resolution } from '@api-types/enums/resolution.enum';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ResolutionService } from 'demand-forecasting/services/resolution.service';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';

import { isForecastSeriesFetchingOrPending } from 'demand-forecasting/store/forecast-series/forecast-series.selectors';
import { ConfigurationRouterHelperService } from 'demand-forecasting/store/router-state/configuration-router-helper.service';
import { selectResolution } from 'demand-forecasting/store/router-state/router.selectors';
import { map, Observable } from 'rxjs';
import { FormFieldComponent, FormInputSelectComponent } from '@libs/ui';
import { FormsModule } from '@angular/forms';

type ResolutionEntry = { label: string; value: Resolution };
@Component({
  selector: 'pm-forecast-resolution',
  templateUrl: './forecast-resolution.component.html',
  imports: [
    TranslateModule,
    AsyncPipe,
    FormFieldComponent,
    FormInputSelectComponent,
    FormsModule,
  ],
})
export class ForecastResolutionComponent {
  private readonly store = inject(Store);
  private readonly translateService = inject(TranslateService);
  private readonly configurationRouterHelperService = inject(
    ConfigurationRouterHelperService,
  );
  private readonly resolutionService = inject(ResolutionService);

  configuration$ = this.store.select(
    ConfigurationsSelectors.selectConfigurationByUrlParam,
  );

  isLoading = this.store.selectSignal(isForecastSeriesFetchingOrPending);

  currentResolution$ = this.store.select(selectResolution).pipe(
    map((resolution) => {
      if (resolution) {
        return {
          label: this.translateService.instant(
            `RESULT.SIDEBAR.RESOLUTION.${resolution.toUpperCase()}`,
          ) as string,
          value: resolution as Resolution,
        };
      }
      return null;
    }),
  );

  resolutionOptions$: Observable<ResolutionEntry[]>;

  constructor() {
    this.resolutionOptions$ = this.configuration$.pipe(
      map((configuration) =>
        configuration
          ? this.resolutionService.getResolutionOptionsByConfiguration(
              configuration,
            )
          : [],
      ),
    );
  }

  onSetResolution(event: Resolution | (Resolution | undefined)[] | undefined) {
    if (!event || Array.isArray(event)) {
      return;
    }
    const resolution = event as Resolution;
    this.configurationRouterHelperService.updateResolution(
      resolution ?? Resolution.Daily,
    );
  }
}
